export const getRoleName = (userRole, id) => {
  let roleName = userRole?.filter(data => data?.id === id)[0]?.name
  return roleName
}
